import { Header } from "../../../components/Landing/Header/haeder.view";
import { HeaderMiradas } from "../../../components/Landing/Header/headerMiradas";
import { Footer } from "../../../components/Landing/Footer";
import { SEO } from "../../../components/SEO/SEO";
import headerMiradas from "../../../assets/miradas/hero2026.jpg"
import { Button } from "antd";
import { useNavigate } from "react-router-dom";
import festival from "../../../assets/miradas/Festival de cine y artes audiovisuales 2026.jpg"
import encuentro from "../../../assets/miradas/Industria Miradas Medellín 2026.jpg"
import banner2026 from "../../../assets/miradas/banner2026.png"
import { ExploraMiradas } from "../../../components/Landing/Miradas/ExploraMiradas";

export const Miradas = () => {
  const navigate = useNavigate();

  const handleNavigation = (route: string) => {
    navigate(route);
  };

  return (
    <>
      <SEO
        title="Miradas Medellín | El lugar de encuentro del nuevo cine iberoamericano"
        description="Miradas Medellín es el lugar de encuentro del nuevo cine iberoamericano. Un espacio que conecta audiencias, cineastas y profesionales del sector audiovisual a través de experiencias de exhibición, formación e industria."
        keywords="Miradas Medellín, Miradas Medellín 2026, festival de cine Medellín, cine iberoamericano, cine en Medellín, festival audiovisual Medellín, Cinemateca Distrital de Medellín, cine colombiano, industria audiovisual Medellín, formación audiovisual Medellín, Encuentro de Coproducción, Programa de Talentos, coproducción audiovisual, mercado audiovisual Medellín, cine latinoamericano, eventos culturales Medellín, festival de cine Colombia, sector audiovisual Medellín"
        ogTitle="Miradas Medellín | El lugar de encuentro del nuevo cine iberoamericano"
        ogDescription="Miradas Medellín es el lugar de encuentro del nuevo cine iberoamericano. Un espacio que conecta audiencias, cineastas y profesionales del sector audiovisual a través de experiencias de exhibición, formación e industria."
        ogImage={headerMiradas}
        ogUrl={`${window.location.origin}/estimuloscultura/miradas`}
      />
      <Header />
      <HeaderMiradas />
      <img src={banner2026} alt="Miradas Medellín 2026" style={{ width: "100%", height: "auto", objectFit: "cover" }} />

      {/* SECCIÓN 1: HOME BANNER */}
      <div style={{ position: "relative" }}>
        <img src={headerMiradas} alt="Miradas Medellín" style={{ width: "100%", height: "auto", objectFit: "cover" }} />
      </div>

      <div className="container-fluid2" style={{ maxWidth: "1000px", margin: "0 auto", padding: "40px 20px" }}>
        <div className="font-family-Montserrat text-center font-color-black">
          <p className="mb-4" style={{ color: '#774747', fontSize: "16px" }}>
            El lugar de encuentro del <strong>nuevo cine iberoamericano</strong>
          </p>
          <h2 className="mb-4" style={{ fontWeight: "bold", fontSize: "28px", color: "#000" }}>
            Del 3 al 8 de noviembre de 2026 · Medellín, Colombia
          </h2>
          <p className="mb-4" style={{ fontSize: "16px", textAlign: "justify" }}>
            Miradas Medellín es un espacio de encuentro para el cine iberoamericano contemporáneo. Una plataforma que reúne películas, experiencias audiovisuales, creadores, audiencias y profesionales del sector audiovisual alrededor de actividades de exhibición, formación e industria que promueven el diálogo, el intercambio y la colaboración.
          </p>
          <p className="mb-4" style={{ fontSize: "16px", textAlign: "justify" }}>
            Desde Medellín, impulsamos la circulación de obras, el fortalecimiento de nuevos talentos y la conexión entre diversas realidades culturales. A través de la <strong>Secretaría de Cultura Ciudadana de Medellín</strong> y la <strong>Cinemateca Distrital de Medellín</strong>, trabajamos para acercar el cine a la ciudadanía y construir espacios donde las múltiples formas de creación, pensamiento y expresión cinematográfica puedan encontrarse.
          </p>
          <p className="mb-5" style={{ fontSize: "16px", textAlign: "justify" }}>
            En <strong>Miradas Medellín</strong> entendemos el cine como una experiencia colectiva capaz de conectar territorios, perspectivas y formas de habitar el mundo. Creemos en las imágenes como espacios de conversación entre quienes las crean y quienes las reciben, generando vínculos duraderos entre las historias, sus realizadores y las comunidades que las hacen parte de su vida cotidiana.
          </p>
        </div>
      </div>

      {/* SECCIÓN 2: UNA APUESTA PÚBLICA */}
      <div style={{ padding: "20px 20px 60px 20px" }}>
        <div className="container-fluid2 font-family-Montserrat" style={{ maxWidth: "800px", margin: "0 auto" }}>
          <h2 className="mb-4 text-center" style={{ color: '#000', fontSize: "24px", fontWeight: "bold" }}>
            Una apuesta pública por el cine y la ciudad
          </h2>
          <p className="mb-4" style={{ fontSize: "16px", textAlign: "justify" }}>
            Desde 2021, <strong>Miradas Medellín</strong> ha construido un espacio para el encuentro entre el cine, la ciudadanía y el sector audiovisual. A lo largo de sus ediciones, hemos reunido películas, creadores, profesionales y audiencias en distintos espacios de Medellín, fortaleciendo una plataforma para la exhibición cinematográfica, la formación especializada y el desarrollo de proyectos audiovisuales.
          </p>
          <p className="mb-4" style={{ fontSize: "16px", textAlign: "justify" }}>
            Hoy, Miradas Medellín continúa ampliando sus vínculos con el ecosistema audiovisual local, nacional e iberoamericano, promoviendo espacios de colaboración, circulación y diálogo alrededor del cine contemporáneo.
          </p>
          <p className="mb-5" style={{ fontSize: "16px", textAlign: "justify" }}>
            En 2025, Miradas Medellín reunió más de <strong>11.500 asistentes</strong> y cerca de <strong>1.200 participantes</strong> en espacios de industria y formación, con programación en salas de cine, espacios culturales, instituciones educativas y diferentes territorios de la ciudad.
          </p>

          <div style={{ backgroundColor: "#22253b", color: "white", padding: "15px", textAlign: "center", marginBottom: "40px" }}>
            <h2 style={{ margin: 0, fontWeight: "bold", color: "white", fontSize: "24px" }}>Festival e industria</h2>
          </div>
        </div>
      </div>

      {/* SECCIÓN 3: FESTIVAL E INDUSTRIA */}
      <div style={{ padding: "0 20px 60px 20px" }}>
        <div className="container-fluid2" style={{ maxWidth: "1000px", margin: "0 auto" }}>
          <div className="row mb-5 align-items-center">
            <div className="col-md-5 order-2 order-md-1 pr-md-5">
              <h3 style={{ marginBottom: "20px" }}>
                <button
                  type="button"
                  onClick={() => handleNavigation('/miradasProgramacion')}
                  style={{ color: '#000', fontWeight: "bold", fontSize: "22px", background: "none", border: "none", padding: 0, cursor: "pointer", textDecoration: "underline", font: "inherit" }}
                >
                  Festival de cine y artes audiovisuales
                </button>
              </h3>
              <p style={{ fontSize: "15px", textAlign: "justify", marginBottom: "30px" }}>
                El Festival reúne una selección de obras que reflejan la diversidad del cine iberoamericano contemporáneo, con películas de <strong>Medellín, Colombia e Iberoamérica</strong>, además de experiencias de cine familiar, accesible, expandido e inmersivo.
              </p>
              <Button
                type="primary"
                style={{ backgroundColor: '#2e66d2', borderColor: '#2e66d2', fontSize: '16px', fontWeight: "bold", height: 'auto', padding: '8px 20px', borderRadius: '5px' }}
                onClick={() => handleNavigation('/miradasProgramacion')}
              >
                Programación 2026
              </Button>
            </div>
            <div className="col-md-7 order-1 order-md-2 mb-4 mb-md-0">
              <img src={festival} alt="Festival" style={{ width: "100%", borderRadius: "5px", objectFit: "cover" }} />
            </div>
          </div>

          <div className="row align-items-center mt-5">
            <div className="col-md-7 mb-4 mb-md-0">
              <img src={encuentro} alt="Industria Miradas Medellín" style={{ width: "100%", borderRadius: "5px", objectFit: "cover" }} />
            </div>
            <div className="col-md-5 pl-md-5">
              <h3 style={{ color: '#000', fontWeight: "bold", marginBottom: "20px", fontSize: "22px" }}>Industria Miradas Medellín</h3>
              <p style={{ fontSize: "15px", textAlign: "justify", marginBottom: "30px" }}>
                A través de sus programas de industria, Miradas Medellín fortalece la creación audiovisual, la formación de nuevos talentos y el desarrollo de proyectos mediante espacios de aprendizaje, acompañamiento y conexión profesional. Esta oferta reúne iniciativas como, <strong>Talentos Miradas</strong>, el <strong>Encuentro de Coproducción</strong> y la <strong>Rueda de Negocios</strong>, que impulsan el intercambio y la colaboración en el sector audiovisual.
              </p>
              <Button
                type="primary"
                style={{ backgroundColor: '#2e66d2', borderColor: '#2e66d2', fontSize: '16px', fontWeight: "bold", height: 'auto', padding: '8px 20px', borderRadius: '5px' }}
                onClick={() => handleNavigation('/miradasIndustria')}
              >
                Conoce las convocatorias
              </Button>
            </div>
          </div>
        </div>
      </div>

      {/* SECCIÓN 4: EXPLORA Y PRÓXIMA EDICIÓN */}
      <div style={{ padding: "0 20px 60px 20px" }}>
        <div className="container-fluid2" style={{ maxWidth: "800px", margin: "0 auto" }}>

          <div style={{ backgroundColor: "#e0e0e0", borderRadius: "10px", padding: "40px", marginBottom: "80px", display: "flex", flexWrap: "wrap", alignItems: "center" }}>
            <div className="col-md-6 mb-3 mb-md-0">
              <h2 style={{ fontWeight: "bold", color: "black", fontSize: "26px", margin: 0, lineHeight: 1.2 }}>
                Del 3 al 8 de<br />noviembre será<br />la próxima edición<br />Miradas Medellín
              </h2>
            </div>
            <div className="col-md-6 pl-md-4">
              <p style={{ fontSize: "15px", margin: 0, color: "#333" }}>
                Próximamente compartiremos más información sobre la programación, actividades e invitados de esta nueva edición.
              </p>
            </div>
          </div>
        </div>
      </div>

      <ExploraMiradas />

      <Footer />
    </>
  );
};